<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button  @click="back" icon="back" bold :text="lang.button_Back"
            :title="lang.button_Back" :disabled="backButtonStatus"/>



        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content   :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/PartManager/Views/UL/Middle/Content/Content"

//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {

      saveButtonStatus: false,
      backButtonStatus: false,
      saving: false,

    }
  },
  computed:{


  },
  created() {


  },
  methods: {
    save(){
      console.log("save")



      var fields = [];

      for (var i = 0, le = this.$store.getters.formDetailsData.data.length; i < le; i++){

        var _key = this.$store.getters.formDetailsData.data[i][0].key
        var _value = this.$store.getters.formDetailsData.data[i][2].display

        fields.push({key: _key, value: _value})
      }

      var _vue = this
      var partKey = "";//this.$store.getters.selectedRows[0][0][0].key
      var obj = {key: partKey, fields:fields}

      var data = this.$store.dispatch(this.$store.getters.sectionPrefix+"_saveData", obj)
                .then(function(result){

                  console.log(result)
                  //this.$store.dispatch(this.$store.getters.sectionPrefix+"_saveData", obj)

                  if (result.ok == true){

                    _vue.saving = true;

                      var obj = {
                        title: "Saving",
                        text: "The data has been saved.",
                        text2: "",
                        type: "info",
                        buttons: 1,
                        size: "sm"
                      }
                      _vue.$store.dispatch("showAlert", obj);
                    }else{
                      var obj = {
                        title: "Saving",
                        text: "The data has not been saved.\n\r ",
                        text2: "Error: " + result.message,
                        type: "info",
                        buttons: 1,
                        size: "sm"
                      }

                     _vue.$store.dispatch("showAlert", obj);
                    }


                })




    },
    back(){
      let to = this.$route.query.from;

      

      
      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query });
    },

  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/UL/Middle/Middle.vue